import { Link, useLocation, useNavigate } from 'react-router-dom'
import './styles/infoclass.css'
import { useEffect, useState } from 'react'

//Components
import Snack from '../components/snack'
import Loader from '../components/loader'
import Confirm from '../components/confirm'
import PlayersComponent from '../components/playerscomponent'
import Menu from '../components/menu'

//Extras
import { fontType, main } from '../assets/extras'
import { addDoc, arrayRemove, arrayUnion, collection, deleteDoc, doc, getDoc, getDocs, increment, query, setDoc, updateDoc, where } from 'firebase/firestore'
import { db } from '../assets/connections'
import { niveles, categorias } from '../assets/datas'
import { IoMdClose } from "react-icons/io"
import { CiSaveDown1 } from "react-icons/ci"
import { HiDocumentDuplicate } from "react-icons/hi"
import { MdDeleteOutline } from "react-icons/md"
import { normalizeClassSedes, filterTeachersBySedes } from '../assets/classUtils'

const InfoClass = () => {

    const navigate = useNavigate()
    
    const location = useLocation()
    
    const ref = location.state ? location.state.ref : null
    const id = location.state ? location.state.id : null
    const academia = location.state ? location.state.academia : null

    const [ variables, setVariables ] = useState({
        loading: true,
        data: null,
        change: false,
        teachers: [],
        teacher: "",
        players: [],
        desc: "",
        allP: {
            checked: false,
            players: []
        },
        modalP: false,
        sedes: [],
        selectedSede: "",
        selectedSedeNombre: ""
    })

    const [ showModal, setShowModal ] = useState(false)
    
    //Horas en formato de 24hrs con medias horas
    const hours = [
        "01:00", "01:30", "02:00", "02:30", "03:00", "03:30", "04:00", "04:30",
        "05:00", "05:30", "06:00", "06:30", "07:00", "07:30", "08:00", "08:30",
        "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30",
        "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30",
        "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00", "20:30",
        "21:00", "21:30", "22:00", "22:30", "23:00", "23:30", "24:00"
    ]

    //Varibles para el uso del confirm
    const [ confirm, setConfirm ] = useState({
        show: false,
        title: "",
        text: ""
    })

    //Varibles para el uso del confirm de la eliminadio
    const [ confirmDup, setConfirmDup ] = useState({
        show: false,
        title: "",
        text: ""
    })

    //Varibles para el uso del confirm de la eliminadio
    const [ confirmDel, setConfirmDel ] = useState({
        show: false,
        title: "",
        text: ""
    })
    
    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Funcion para eliminar jugador de la clinica
    const takeOutPlayer = async  (data, index) =>{
       //Lo actualizamos en tiempo real, primero borramos al jugador
       //Y luego actualizamos el contador de asistencias
       await updateDoc(doc(doc(db, ref), "Jugador", data.id), {
            clases_jugador: arrayRemove(id)
        }).then(async r => {
            await updateClassContDelete()
            variables.players.splice(index, 1)
            setVariables(prev => ({
                ...prev 
            }))
            showMessage("Jugador eliminado exitosamente de la clase", "success")
        }).catch(e => {
            console.log(e)
            showMessage("Error al eliminar jugador de la clase", "error")
        })

    }
    //Funcion que actualiza el contador de jugadores de la clinica
    const updateClassContDelete = async () => {
        await updateDoc(doc(doc(db, ref), "Clases", id), {
            numero_jugadores: increment(-1)
        }).catch(e => {
            console.log(e)
        })
    }

    //Funcion que agrega a un jugador nuevo a la lista
    const addNewPlayer = async (data) => {
        let playerInfo = {
            id: data.id,
            nombre_jugador: data.nombre_jugador
        }

        if(variables.data.limite_jugadores == 0){
            var cont = 0
            for(let i = 0; i < variables.players.length; i++){
                if(playerInfo.id == variables.players[i].id){
                    cont ++
                }
            }

            //Validamos que el jugador no exista ya en la clinica
            if(cont == 0){

                //Lo actualizamos en tiempo real, primero agregamos al jugador
                //Y luego actualizamos el contador de asistencias
                await updateDoc(doc(doc(db, ref), "Jugador", playerInfo.id), {
                    clases_jugador: arrayUnion(id)
                }).then(async r => {
                    await updateClassContAdd()
                    variables.players.push({
                        id: playerInfo.id,
                        nombre_jugador: playerInfo.nombre_jugador
                    })
            
                    setVariables(prev => ({
                        ...prev
                    }))
                    showMessage("Jugador agregado exitosamente a la clase", "success")
                }).catch(e => {
                    console.log(e)
                    showMessage("Error al eliminar jugador de la clase", "error")
                })
            } else {
                showMessage("El jugador ya esta agregado en la lista", "warning")
            }
        } else { 

            if(variables.players.length < variables.data.limite_jugadores){
                var cont = 0
                for(let i = 0; i < variables.players.length; i++){
                    if(playerInfo.id == variables.players[i].id){
                        cont ++
                    }
                }
                if(cont == 0){
                    //Lo actualizamos en tiempo real, primero agregamos al jugador
                    //Y luego actualizamos el contador de asistencias
                    await updateDoc(doc(doc(db, ref), "Jugador", playerInfo.id), {
                        clases_jugador: arrayUnion(id)
                    }).then(async r => {
                        await updateClassContAdd()
                        variables.players.push({
                            id: playerInfo.id,
                            nombre_jugador: playerInfo.nombre_jugador
                        })
                
                        setVariables(prev => ({
                            ...prev
                        }))
                        showMessage("Jugador agregado exitosamente a la clase", "success")
                    }).catch(e => {
                        console.log(e)
                        showMessage("Error al eliminar jugador de la clase", "error")
                    })

                    } else {
                        showMessage("El jugador ya esta agregado en la lista", "warning")
                    }
            } else {
                showMessage("Ya no hay espacio en la clase", "warning")
            }
        }
    }
    //Funcion que actualiza el contador de jugadores de la clinica
    const updateClassContAdd = async () => {
        await updateDoc(doc(doc(db, ref), "Clases", id), {
            numero_jugadores: increment(1)
        }).catch(e => {
            console.log(e)
        })
    }

    //Funciones que actualiza la informacion
    const handleSave = () => {
        if(variables.teacher){
            if(variables.data.descripcion_clase){

                var valid = true
                if(!variables.data.isGroup){
                    if(!variables.data.nombre_clase){
                        valid = false
                    }
                }

                if(valid){
                    if(variables.data.categoria != "null"){
                        if(variables.data.nivel != "null"){
                            if(variables.data.dias_clase.length > 0){
                                var cont = 0
                                for(let i = 0; i < variables.data.dias_clase.length; i++){
                                    if(!variables.data.dias_clase[i].dia || !variables.data.dias_clase[i].de || !variables.data.dias_clase[i].a){
                                        cont ++
                                    }
                                }
                                if(cont > 0){
                                    showMessage("Debes completar los datos de los dias de clase", "warning")
                                } else {
                                    if(variables.data.limite_jugadores){
                                        if(variables.data.limite_jugadores >= 0 && variables.data.limite_jugadores <= 12){
                                            if (variables.data.limite_jugadores == 0 || (variables.data.limite_jugadores >= variables.players.length)) {
                                                setConfirm(prev => ({
                                                    ...prev, 
                                                    show: true,
                                                    title:"ACTUALIZACION DE DATOS" ,
                                                    text: "¿Estas seguro de actualizar los datos de la clase?"
                                                }))
                                            } else {
                                                showMessage("El limite debe ser mayor o igual a la cantidad de jugadores en la clase", "warning")
                                            }
                                        } else {
                                            showMessage("El limite de jugadores debe de ser entre 0 y 12", "warning")
                                        }
                                    } else if(!variables.data.limite_jugadores){
                                        setConfirm(prev => ({
                                            ...prev, 
                                            show: true,
                                            title: "ACTUALIZACION DE DATOS",
                                            text: "¿Estas seguro de actualizar los datos de la clase?"
                                        }))
                                    }
                                }
                            } else {
                                showMessage("No hay dias para la clase", "warning")
                            }
                        } else {
                            showMessage("Debes seleccionar un nivel para la clase", "warning")
                        }
                    } else {
                        showMessage("Debes seleccionar una categoria para la clase", "warning")
                    }
                } else {
                    showMessage("Debes darle un nombre a la clase", "warning")
                }
            } else {
                showMessage("Debes agregar una descripcion de clase", "warning")
            }
        } else {
            showMessage("No has seleccionado un porofesor", "warning")
        }
    }
    const saving = async () => {

        setConfirm(prev => ({
            ...prev,
            show: false
        }))

        setVariables(prev => ({
            ...prev,
            loading: true
        }))

        await updateDoc(doc(doc(db, ref), "Clases", id), {
            profesor_clase: variables.teacher,
            categoria: variables.data.categoria,
            nivel: variables.data.nivel,
            descripcion_clase: variables.data.descripcion_clase,
            dias_clase: variables.data.dias_clase,
            nombre_clase: variables.data.isGroup ? (variables.data.nivel + " / " + variables.data.categoria) : variables.data.nombre_clase,
            limite_jugadores: variables.data.limite_jugadores ? variables.data.limite_jugadores : 0,
            nombre_profesor: variables.data.nombre_profesor,
            profesor_clase_secundario: variables.data.profesor_clase_secundario || "",
            nombre_profesor_secundario: variables.data.nombre_profesor_secundario || "",
            isGroup: variables.data.isGroup,
            sede: variables.selectedSede || "",
            nombre_sede: variables.selectedSedeNombre || ""
        }).then(r => {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Clase actualizada", "success")
            }, 100)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    //Funcion que duplica la la clinica
    const handleDuplicate = () => {
        setConfirmDup(prev => ({
            ...prev,
            show: false
        }))
        setVariables(prev => ({
            ...prev,
            loading: true
        }))
        duplicating()
    }
    const duplicating = async () => {
        await addDoc(collection(doc(db, ref), "Clases"), {
            ...variables.data,
            descripcion_clase: variables.desc === "" ? variables.data.descripcion_clase + " (COPIA)" : variables.desc,
            clases_muestra: 0
        }).then(r => {
            createHistoryClass(r.id)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }
    const createHistoryClass = async (id) => {
        await setDoc(doc(doc(db, ref), "Historial", id), {
            id
        }).then(r => {
            updatePlayers(id)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }
    const updatePlayers = async (id) => {
        var cont = 0
        for(let i = 0; i < variables.players.length; i++){
            await updateDoc(doc(doc(db, ref), "Jugador", variables.players[i].id), {
                clases_jugador: arrayUnion(id)
            }).then(r => {
                cont ++
            })
        }

        if(cont == variables.players.length){
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Clase duplicada", "success")
                setTimeout(() => {
                    window.history.back()
                }, 1000)
            }, 100)
        } else {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Algunos cambios no fueron modificados correctamente", "success")
            }, 100)
        }
    }

    //Funciones que borran la clinica
    const handleDelete = () => {
        setConfirmDel(prev => ({
            ...prev,
            show: false
        }))
        setVariables(prev => ({
            ...prev,
            loading: true
        }))
        
        deleting()
    }
    const deleting = async () => {
        await deleteDoc(doc(doc(db, ref), "Clases", id)).then(r => {
            //Eliminamos el historial de la clinica
            deleteHistory(id)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }
    const deleteHistory = async (id) => {
        await deleteDoc(doc(doc(db, ref), "Historial", id)).then(r => {
            //Eliminamos los jugadores de la clinica
            deletePlayers(id)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }
    const deletePlayers = async (id) => {
        var jugadores = []
        await getDocs(query(collection(doc(db, ref), "Jugador"), where("clases_jugador", "array-contains", id))).then(docs => {
            docs.docs.map((v, i) => {
                jugadores.push(v.id)
            })
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })

        for(let i = 0; i < jugadores.length; i++){
            await updateDoc(doc(doc(db, ref), "Jugador", jugadores[i]), {
                clases_jugador: arrayRemove(id)
            })
        }
        setVariables(prev => ({
            ...prev,
            loading: false
        }))
        setTimeout(() => {
            showMessage("Clase borrada con exito", "success")
            setTimeout(() => {
                window.history.back()
            }, 1000)
        }, 100)
    }

    const getStudents = async (clinicData, teachers, profesor) => {
        //Obtenemos a los jugadores
        await getDocs(query(collection(doc(db, ref), "Jugador"), where("clases_jugador", "array-contains", id))).then(r2 => {
            var aux = []
            r2.docs.map(v => {
                aux.push({
                    id: v.id,
                    nombre_jugador: v.data().nombre_jugador,
                    apellido_p_jugador: v.data().apellido_p_jugador
                })
            })

            setVariables(prev => ({
                ...prev,
                data: clinicData,
                teachers: teachers,
                teacher: profesor,
                players: aux,
                loading: false
            }))
        })
    }

    const getTeachers = async (clinicData) => {
        await getDocs(query(collection(db, "Profesores"), where("academia_profesor", "array-contains", academia))).then(r => {
            if(r.docs.length > 0){
                var aux = []
                r.docs.map(v => {
                    var newObject = {
                        ...v.data(),
                        id: v.id
                    }
                    aux.push(newObject)
                })

                getStudents(clinicData, aux, clinicData.profesor_clase)

            }
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    const getData = async () => {
        try {
            // Cargar clase y sedes en paralelo
            const [clinicSnap, sedesSnap] = await Promise.all([
                getDoc(doc(doc(db, ref), "Clases", id)),
                getDocs(collection(doc(db, ref), "Sedes"))
            ])

            const data = clinicSnap.data()
            // Asegurar que cada día tenga el campo duracion inicializado
            if(data.dias_clase && Array.isArray(data.dias_clase)){
                data.dias_clase = data.dias_clase.map(dia => ({
                    ...dia,
                    duracion: dia.duracion || ""
                }))
            }

            // Cargar sedes
            var sedesAux = []
            sedesSnap.docs.forEach(v => {
                sedesAux.push({ id: v.id, ...v.data() })
            })

            // Normalizar sedes de la clase
            const { sedes: classSedes, nombres_sedes } = normalizeClassSedes(data)

            setVariables(prev => ({
                ...prev,
                sedes: sedesAux,
                selectedSede: classSedes[0] || "",
                selectedSedeNombre: nombres_sedes[0] || ""
            }))

            getTeachers(data)
        } catch(e) {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        }
    }

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        } else {
            getData()
        }
    }, [])

    if(variables.loading)
    return (
        <Loader loading={variables.loading} />
    )

    if(!variables.loading)
    return (
        <div className='mainInfoClass'>

            <Snack />

            <Confirm
                confirm={confirm}
                setConfirm={setConfirm}
                onHandle={saving}
            />

            <Confirm
                confirm={confirmDup}
                setConfirm={setConfirmDup}
                onHandle={handleDuplicate}
            />

            <Confirm
                confirm={confirmDel}
                setConfirm={setConfirmDel}
                onHandle={handleDelete}
            />

            {
                showModal === true ?
                    <PlayersComponent
                        reference={ref}
                        addPlayer={addNewPlayer}
                        showModal={showModal}
                        setShowModal={setShowModal}
                    />
                : null
            }

            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.title,
                paddingBottom: 0
            }}>{variables.data.isGroup ? (variables.data.nivel + " / " + variables.data.categoria) : variables.data.nombre_clase}</h2>
            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.text,
                marginTop: -50,
                marginBottom: 40,
                fontSize: 18,
                padding: 10,
                paddingBottom: 20,
                paddingTop: 0
            }}>{
                localStorage.getItem("authToken") ? 
                    JSON.parse(localStorage.getItem("authToken")).nombre_academia
                : ""
            }</h2>

            <Menu
                academia={academia}
                reference={ref}
            />

            <div className='contInfoClass'>

                <div className='infoClass'>

                    <div className='info-item'>
                        <p style={{
                            fontFamily: fontType.text
                        }}>Nombre de la clase</p>
                        <input
                            style={{
                                borderColor: "#DDD",
                                fontFamily: fontType.text
                            }}
                            
                            value={variables.data.isGroup ? (variables.data.nivel + " / " + variables.data.categoria) : variables.data.nombre_clase}
                            maxLength={50}
                            onChange={e => {
                                const t = e.target.value

                                setVariables(prev => ({
                                    ...prev,
                                    data: {
                                        ...prev.data,
                                        nombre_clase: t
                                    }
                                }))
                            }}
                            disabled={variables.data.isGroup}
                        />
                    </div>

                    <div style={{marginBottom: 30}} className='info-item'>
                        <p  style={{
                            fontFamily: fontType.text
                        }}>Descripcion de la clase</p>
                        <input
                            style={{
                                borderColor: "#DDD",
                                fontFamily: fontType.text
                            }}
                            value={variables.data.descripcion_clase}
                            maxLength={200}
                            onChange={e => {
                                const t = e.target.value

                                setVariables(prev => ({
                                    ...prev,
                                    data: {
                                        ...prev.data,
                                        descripcion_clase: t
                                    }
                                }))
                            }}
                        />
                    </div>

                    <div className='checkbox-cont'>
                        <input type="checkbox" id="check1" checked={variables.data.isGroup} onChange={() => {
                            setVariables(prev => ({
                                ...prev,
                                data: {
                                    ...prev.data,
                                    isGroup: !variables.data.isGroup
                                }
                            }))
                        }} /><label for="check1" style={{
                            fontFamily: fontType.text
                        }}>Clase grupal</label>
                    </div>

                    {variables.sedes.length > 0 && (
                        <div style={{ marginBottom: 30 }} className='info-item'>
                            <p style={{
                                fontFamily: fontType.text
                            }}>Sede</p>
                            <div className='custom-select' style={{ width: "100%" }}>
                                <select style={{
                                    fontFamily: fontType.text,
                                    width: "100%",
                                    padding: 10,
                                    fontSize: 16,
                                    borderRadius: 8,
                                    border: "2px solid #ddd",
                                    outline: "none"
                                }}
                                    value={variables.selectedSede}
                                    onChange={e => {
                                        const sedeId = e.target.value
                                        const sede = variables.sedes.find(s => s.id === sedeId)
                                        setVariables(prev => ({
                                            ...prev,
                                            selectedSede: sedeId,
                                            selectedSedeNombre: sede ? sede.nombre_sede : ""
                                        }))
                                    }}
                                >
                                    <option value="">Sin sede</option>
                                    {variables.sedes.map(s => (
                                        <option key={s.id} value={s.id}>{s.nombre_sede}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}

                    <div className='contData' style={{
                        border: "2px solid " + main
                    }}>

                        <div className='contSelect'>
                            <p style={{
                                fontFamily: fontType.text,
                                fontWeight: "bolder",
                                marginBottom: 8
                            }}>Cambiar profesor: <span onClick={() => {
                                setVariables(prev => ({
                                    ...prev,
                                    loading: true
                                }))
                                setTimeout(async () => {
                                    await getDoc(doc(db, "Profesores", variables.teacher)).then(r => {
                                        navigate("/teachers/teacher", {state: {
                                            ref: ref,
                                            data: {
                                                ...r.data(),
                                                id: r.data().correo_profesor
                                            },
                                            academia: academia
                                        }})
                                    }).catch(e => {
                                        console.log(e)
                                        setVariables(prev => ({
                                            ...prev,
                                            loading: false
                                        }))
                                        setTimeout(() => {
                                            showMessage("Ocurrio algun error", "error")
                                        }, 50)
                                    })
                                }, 50)
                            }}>{variables.data.nombre_profesor}</span></p>
                            <div className='custom-select'>

                                <select id="Profesor" name="Profesor" style={{
                                    fontFamily: fontType.text
                                }}
                                    onChange={e => {
                                        const t = JSON.parse(e.target.value)

                                        setVariables(prev => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                nombre_profesor: t.nombre_profesor
                                            },
                                            teacher: t.correo_profesor
                                        }))

                                    }}
                                >
                                    {
                                        filterTeachersBySedes(variables.teachers, academia, [variables.selectedSede]).map((v, i) => {
                                            return (
                                                <option key={i} value={
                                                    JSON.stringify({correo_profesor: v.correo_profesor, nombre_profesor: v.nombre_profesor + " " + v.apellido_p_profesor})
                                                }>{v.nombre_profesor + " " + v.apellido_p_profesor}</option>
                                            )
                                        })
                                    }
                                </select>

                            </div>
                        </div>

                        <div className='contSelect'>
                            <p style={{
                                fontFamily: fontType.text,
                                fontWeight: "bolder",
                                marginBottom: 8
                            }}>Profesor Secundario (opcional): {variables.data.nombre_profesor_secundario && <span>{variables.data.nombre_profesor_secundario}</span>}</p>
                            <div className='custom-select'>

                                <select id="ProfesorSecundario" name="ProfesorSecundario" style={{
                                    fontFamily: fontType.text
                                }}
                                    value={
                                        variables.data.profesor_clase_secundario
                                            ? JSON.stringify({
                                                correo_profesor: variables.data.profesor_clase_secundario,
                                                nombre_profesor: variables.data.nombre_profesor_secundario
                                            })
                                            : ""
                                    }
                                    onChange={e => {
                                        const t = e.target.value ? JSON.parse(e.target.value) : null

                                        setVariables(prev => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                nombre_profesor_secundario: t ? t.nombre_profesor : "",
                                                profesor_clase_secundario: t ? t.correo_profesor : ""
                                            }
                                        }))

                                    }}
                                >
                                    <option value="">Sin profesor secundario</option>
                                    {
                                        filterTeachersBySedes(variables.teachers, academia, [variables.selectedSede]).map((v, i) => {
                                            return (
                                                <option key={i} value={
                                                    JSON.stringify({correo_profesor: v.correo_profesor, nombre_profesor: v.nombre_profesor + " " + v.apellido_p_profesor})
                                                }>{v.nombre_profesor + " " + v.apellido_p_profesor}</option>
                                            )
                                        })
                                    }
                                </select>

                            </div>
                        </div>

                        <div className='contSelect'>
                            <p style={{
                                fontFamily: fontType.text,
                                fontWeight: "bolder",
                                marginBottom: 8
                            }}>Categoria</p>
                            <div className='custom-select'>
                                <select id="Categoria" name="Categoria" style={{
                                    fontFamily: fontType.text
                                }}
                                    value={variables.data.categoria}
                                    onChange={e => {
                                        const t = e.target.value
                                        setVariables(prev => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                categoria: t
                                            }
                                        }))
                                    }}
                                >
                                    <option value="null">Todos</option>
                                    {
                                        categorias.map(v => {
                                            return (
                                                <option value={v}>{v}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        <div className='contSelect'>
                            <p style={{
                                fontFamily: fontType.text,
                                fontWeight: "bolder",
                                marginBottom: 8
                            }}>Nivel</p>
                            <div className='custom-select'>
                                <select id="Nivel" name="Nivel" style={{
                                    fontFamily: fontType.text
                                }}
                                    value={variables.data.nivel}
                                    onChange={e => {
                                        const t = e.target.value
                                        setVariables(prev => ({
                                            ...prev,
                                            data: {
                                                ...prev.data,
                                                nivel: t
                                            }
                                        }))
                                    }}
                                >
                                    <option value="null">Todos</option>
                                    {
                                        niveles.map(v => {
                                            return (
                                                <option value={v}>{v}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        <div className='contLimite'>
                            <p style={{
                                fontFamily: fontType.text,
                                fontWeight: "bolder",
                                marginBottom: 8
                            }}>Limite de jugadores</p>
                            <div className='custom-select'>
                                <select id="Limite" name="Limite" style={{
                                    fontFamily: fontType.text,
                                    width: "100%"
                                }}
                                value={parseInt(variables.data.limite_jugadores)}
                                    onChange={e => {
                                        const t = e.target.value

                                        setVariables(prev => ({
                                            ...prev, 
                                            data: { 
                                                ...prev.data, 
                                                limite_jugadores: t
                                            }
                                        }))

                                    }}
                                >
                                    <option value={0}>Ninguno</option>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                    <option value={6}>6</option>
                                    <option value={7}>7</option>
                                    <option value={8}>8</option>
                                    <option value={9}>9</option>
                                    <option value={10}>10</option>
                                    <option value={11}>11</option>
                                    <option value={12}>12</option>
                                </select>
                            </div>
                        </div>

                    </div>

                    <p style={{
                        fontFamily: fontType.title,
                        fontWeight: "bold",
                        fontSize: 25,
                        marginBottom: 10
                    }}>DIAS DE CLASE</p>

                    <div className='contDias'>
                        {
                            variables.data.dias_clase.map((v, i) => {
                                return (
                                    <div className='dia' key={i}>
                                        <div className='dia-out'>
                                            <IoMdClose id='outdia' size={20} color='#C00' onClick={() => {
                                            //Sacar dia
                                            variables.data.dias_clase.splice(i, 1)
                                            setVariables(prev => ({
                                                ...prev
                                            }))
                                        }} />
                                        </div>

                                        <div className='dia-dia'>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold"
                                            }}>Dia de la clase:</p>
                                            <div className='custom-select'>
                                                <select id="Dia de la clase" name="Dia de la clase" style={{
                                                    fontFamily: fontType.text
                                                }}
                                                    value={v.dia}
                                                    onChange={e => {
                                                        variables.data.dias_clase[i].dia = e.target.value
                                                        setVariables(prev => ({
                                                            ...prev
                                                        }))
                                                    }}
                                                >
                                                    <option value="Lunes">Lunes</option>
                                                    <option value="Martes">Martes</option>
                                                    <option value="Miercoles">Miercoles</option>
                                                    <option value="Jueves">Jueves</option>
                                                    <option value="Viernes">Viernes</option>
                                                    <option value="Sabado">Sabado</option>
                                                    <option value="Domingo">Domingo</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className='dia-de'>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold"
                                            }}>De:</p>
                                            <div className='custom-select'>
                                                <select id="De" name="De" style={{
                                                    fontFamily: fontType.text
                                                }}
                                                    value={v.de}
                                                    onChange={e => {
                                                        variables.data.dias_clase[i].de = e.target.value

                                                        // Calcular hora fin si hay duración seleccionada
                                                        if (variables.data.dias_clase[i].duracion && e.target.value) {
                                                            // Parsear la hora de inicio (formato "HH:MM")
                                                            const [horasInicio, minutosInicio] = e.target.value.split(':').map(Number)
                                                            const duracion = parseFloat(variables.data.dias_clase[i].duracion)

                                                            // Convertir todo a minutos para hacer la suma
                                                            const minutosInicioTotal = (horasInicio * 60) + minutosInicio
                                                            const minutosAgregar = duracion * 60
                                                            const minutosFinTotal = minutosInicioTotal + minutosAgregar

                                                            // Convertir de vuelta a horas y minutos
                                                            const horaFinNum = Math.floor(minutosFinTotal / 60)
                                                            const minutosFin = minutosFinTotal % 60

                                                            // Formatear la hora de fin
                                                            const horaFinStr = `${horaFinNum.toString().padStart(2, '0')}:${minutosFin.toString().padStart(2, '0')}`
                                                            variables.data.dias_clase[i].a = horaFinStr
                                                        }

                                                        setVariables(prev => ({
                                                            ...prev
                                                        }))
                                                    }}
                                                >
                                                    <option value={""}>...</option>
                                                    {
                                                        hours.map((v) => {
                                                            return (
                                                                <option value={v}>{v}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>

                                        <div className='dia-duracion'>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold"
                                            }}>Duración:</p>
                                            <div className='custom-select'>
                                                <select id="Duracion" name="Duracion" style={{
                                                    fontFamily: fontType.text
                                                }}
                                                    value={v.duracion || ""}
                                                    onChange={e => {
                                                        variables.data.dias_clase[i].duracion = e.target.value

                                                        // Calcular hora fin si hay hora inicio seleccionada
                                                        if (variables.data.dias_clase[i].de && e.target.value) {
                                                            // Parsear la hora de inicio (formato "HH:MM")
                                                            const [horasInicio, minutosInicio] = variables.data.dias_clase[i].de.split(':').map(Number)
                                                            const duracion = parseFloat(e.target.value)

                                                            // Convertir todo a minutos para hacer la suma
                                                            const minutosInicioTotal = (horasInicio * 60) + minutosInicio
                                                            const minutosAgregar = duracion * 60
                                                            const minutosFinTotal = minutosInicioTotal + minutosAgregar

                                                            // Convertir de vuelta a horas y minutos
                                                            const horaFinNum = Math.floor(minutosFinTotal / 60)
                                                            const minutosFin = minutosFinTotal % 60

                                                            // Formatear la hora de fin
                                                            const horaFinStr = `${horaFinNum.toString().padStart(2, '0')}:${minutosFin.toString().padStart(2, '0')}`
                                                            variables.data.dias_clase[i].a = horaFinStr
                                                        }

                                                        setVariables(prev => ({
                                                            ...prev
                                                        }))
                                                    }}
                                                >
                                                    <option value={""}>...</option>
                                                    <option value="1">1 Hora</option>
                                                    <option value="1.5">1 Hora 30 Min</option>
                                                    <option value="2">2 Horas</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className='dia-a'>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold"
                                            }}>A:</p>
                                            {variables.data.dias_clase[i].a && typeof variables.data.dias_clase[i].a === 'string' && variables.data.dias_clase[i].a.includes(":") ? (
                                                <input
                                                    type="text"
                                                    style={{
                                                        fontFamily: fontType.text,
                                                        borderColor: "#DDD",
                                                        borderWidth: 2,
                                                        borderStyle: "solid",
                                                        borderRadius: 5,
                                                        padding: 8,
                                                        width: "100%",
                                                        outline: "none"
                                                    }}
                                                    value={variables.data.dias_clase[i].a}
                                                    placeholder="Ej: 10:30"
                                                    onChange={e => {
                                                        variables.data.dias_clase[i].a = e.target.value
                                                        setVariables(prev => ({
                                                            ...prev
                                                        }))
                                                    }}
                                                />
                                            ) : (
                                                <div className='custom-select'>
                                                    <select id="A" name="A" style={{
                                                        fontFamily: fontType.text
                                                    }}
                                                        value={variables.data.dias_clase[i].a}
                                                        onChange={e => {
                                                            variables.data.dias_clase[i].a = e.target.value
                                                            setVariables(prev => ({
                                                                ...prev
                                                            }))
                                                        }}
                                                    >
                                                        <option value={""}>...</option>
                                                        {
                                                            hours.map((v) => {
                                                                return (
                                                                    <option value={v}>{v}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className='dia-agregar'>
                        <button style={{
                            backgroundColor: main,
                            fontFamily: fontType.subTitle
                        }} onClick={() => {
                            variables.data.dias_clase.push({
                                dia: "",
                                de: "",
                                a: "",
                                duracion: ""
                            })
                            setVariables(prev => ({
                                ...prev
                            }))
                        }}>AGREGAR DIA</button>
                    </div>

                </div>

                <div className='playersClass'>

                    <p style={{
                        fontFamily: fontType.title,
                        marginBottom: 10,
                        fontSize: 25
                    }}>JUGADORES {variables.players.length}/{variables.data.limite_jugadores == 0 || 
                    !variables.data.limite_jugadores ? "∞" : variables.data.limite_jugadores}</p>

                    {
                        variables.data.isGroup === true ?
                            <p style={{
                                fontFamily: fontType.title,
                                marginBottom: 10,
                                fontSize: 25,
                                border: "1px solid black",
                                padding: 10,
                                borderRadius: 5
                            }}>CLASES MUESTRA: {variables.data.clases_muestra ? variables.data.clases_muestra : "0"}</p>
                        : null
                    }

                    <div className='contPlayers'>
                        {
                            variables.players.map((v, i) => {
                                return (
                                    <div className='player'>
                                        <Link to={"/players/player"} state={{
                                            ref: ref,
                                            academia: academia,
                                            id: v.id
                                        }} style={{
                                            fontFamily: fontType.text,
                                            fontWeight: "bold",
                                            width: "90%",
                                            height: "100%",
                                            flex: 9,
                                            display: "flex",
                                            alignItems: "center",
                                            color: "black",
                                            textDecoration: "none"
                                        }}>{v.nombre_jugador}</Link>
                                        <IoMdClose id='outplayer' size={20} color='#C00' onClick={() => {
                                            takeOutPlayer(v, i)
                                        }} style={{
                                            height: 25,
                                            flex: 1
                                        }} />
                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className='player-agregar'>
                        <button style={{
                            backgroundColor: main
                        }} onClick={() => {
                            setShowModal(true)
                        }}>AGREGAR JUGADOR</button>
                    </div>

                    <div className='contButtons'>
                        <button style={{backgroundColor: main}} onClick={() => {
                            handleSave()
                        }}>
                            <p style={{
                                fontFamily: fontType.subTitle,
                                marginLeft: 10,
                                fontWeight: "bold",
                                color: "white"
                            }}>GUARDAR</p>
                            <CiSaveDown1 size={25} color='white' />
                        </button>
                        <button style={{
                            backgroundColor: "orange"
                        }} onClick={() => {
                            setConfirmDup(prev => ({
                                show: true,
                                title: "DUPLICAR CLASE",
                                text: "¿Estas seguro de duplicar esta clase?\n(Antes de duplicar asegurate primero de guardar los cambios realizados)"
                            }))
                        }}>
                            <p style={{
                                fontFamily: fontType.subTitle,
                                marginLeft: 10,
                                color: "white"
                            }}>DUPLICAR</p>
                            <HiDocumentDuplicate size={25} color='white' />
                        </button>
                        <button style={{
                            backgroundColor: "#A00"
                        }} onClick={() => {
                            if(variables.data.isGroup){
                                if(variables.data.clases_muestra <= 0){
                                    setConfirmDel(prev => ({
                                        ...prev,
                                        show: true,
                                        text: "¿Estas seguro de eliminar esta clase?",
                                        title: "ELIMINAR CLASE"
                                    }))
                                } else {
                                    showMessage("Tienes clases muestra. No puedes eliminar la clase.", "warning")
                                }
                            } else {
                                setConfirmDel(prev => ({
                                    ...prev,
                                    show: true,
                                    text: "¿Estas seguro de eliminar esta clase?",
                                    title: "ELIMINAR CLASE"
                                }))
                            }

                        }}>
                            <p  style={{
                                fontFamily: fontType.subTitle,
                                marginLeft: 10,
                                color: "white"
                            }}>ELIMINAR</p>
                            <MdDeleteOutline size={25} color='white' />
                        </button>
                    </div>

                </div>

            </div>

        </div>
    )
}

export default InfoClass